import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const sectionHeadingRecipe = defineSlotRecipe({
  className: 'section-heading',
  slots: ['root', 'contentBlock', 'titleBlock', 'icon', 'label', 'helperBlock', 'helperText'],
  base: {
    root: {
      alignItems: 'end',
      display: 'flex',
      gap: '32',
    },
    contentBlock: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: '4',
      minWidth: 0,
    },
    titleBlock: {
      alignItems: 'center',
      display: 'flex',
      gap: '6',
    },
    icon: {
      color: 'icon/tertiary',
      flexShrink: 0,
    },
    label: {
      color: 'text/primary',
      textStyle: 'heading/h3',
    },
    helperBlock: {
      alignItems: 'center',
      display: 'flex',
      gap: '4',
    },
    helperText: {
      color: 'text/secondary',
      textStyle: 'body/md/regular',
    },
  },
});

export default sectionHeadingRecipe;
